import { render, staticRenderFns } from "./signRecordDetail.vue?vue&type=template&id=06e426ed&scoped=true&"
import script from "./signRecordDetail.vue?vue&type=script&lang=js&"
export * from "./signRecordDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e426ed",
  null
  
)

export default component.exports